import tryPerformRowAutoMarkAsRead from '../../helpers/tryPerformRowAutoMarkAsRead';
import TableView from 'owa-mail-list-store/lib/store/schema/TableView';
import UserOptionsType from 'owa-service/lib/contract/UserOptionsType';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { action, select } from 'satcheljs/lib/legacy';

export interface OnNavigateAwayViaUpDownState {
    userOptions: UserOptionsType;
}

/**
 * Called on navigate away via up/down buttons from command bar
 * @param rowKey the rowKey to be marked as read
 * @param tableView the table view
 * @param state the OnNavigateAwayViaUpDownState which contains the user options
 */
export default action('onNavigateAwayViaUpDown')(
    select({
        userOptions: () => getUserConfiguration().UserOptions,
    })(function onNavigateAwayViaUpDown(
        rowKey: string,
        tableView: TableView,
        state?: OnNavigateAwayViaUpDownState
    ) {
        if (state.userOptions.PreviewMarkAsRead == 'OnSelectionChange') {
            tryPerformRowAutoMarkAsRead(rowKey, tableView);
        }
    })
);
